import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestRatingDismissDelete = {
    path: "/rating/:slug/dismiss",
    method: RouteHttpVerb.DELETE
};
export { locationRestRatingDismissDelete };
